import React, { useState } from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { QuestionHeader, QuestionIndex, QuestionStatement } from '../../../components';

const TextArea = styled.textarea`
  width: 100%;
  min-height: 140px;
  border: 1px solid #d7dbe3;
  border-radius: 4px;
  padding: 12px;
  font-size: 16px;
  resize: vertical;
  box-sizing: border-box;
  &:focus {
    outline: 2px solid #279989;
    border-color: #279989;
  }
  &:disabled {
    background: #fafafa;
    color: #444;
    cursor: default;
  }
`;

const FreeTextQuestion = ({
  id,
  index,
  statement,
  attachments,
  disabled,
  defaultValue,
  onAddAnswer,
  onRemoveAnswer,
}) => {
  const [text, setText] = useState(defaultValue ?? '');

  const handleChange = e => {
    const value = e.target.value;
    setText(value);
    if (value.trim().length > 0) {
      onAddAnswer(id, value);
    } else {
      onRemoveAnswer(id);
    }
  };

  return (
    <div>
      <QuestionHeader>
        <QuestionIndex>{`Question ${index + 1}`}</QuestionIndex>
        <QuestionStatement>{statement}</QuestionStatement>
        {!_.isNil(attachments) && attachments.length > 0 && attachments[0].type === 'Image' ? (
          <img className="col-9" src={attachments[0].path} alt="attachment" />
        ) : (
          ''
        )}
      </QuestionHeader>
      <div className="mt3">
        <TextArea
          value={text}
          onChange={handleChange}
          disabled={disabled}
          maxLength={4000}
          placeholder="Type your answer here..."
        />
      </div>
    </div>
  );
};

export default FreeTextQuestion;
